import axios from 'axios';

export default class HttpClient {
  baseUrl: string;
  client: typeof axios;

  constructor(baseUrl: string) {
    this.client = axios;
    this.baseUrl = baseUrl || '';
  }

  fullUrl(uri: string) {
    return `${this.baseUrl}${uri}`;
  }

  get(uri: string, data?: object) {
    return this.client.get(this.fullUrl(uri), data);
  }

  post(uri: string, data: object, config?: object) {
    return this.client.post(this.fullUrl(uri), data, config);
  }

  put(uri: string, data: object, config?: object) {
    return this.client.put(this.fullUrl(uri), data, config);
  }
}
